import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogComponent } from 'src/app/shared/dialog/confirm.dialog';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    constructor(
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private zone: NgZone
    ) {}

    showClientError(message: string): void {
        this.snackbar.open(`Error: ${message}`, 'Okay', {
            panelClass: ['error-snack'], // add a class to snackbar to add custom styles
        });
    }

    openServerErrorDialog(message: string) {
        this.snackbar.open(`Error: ${message}`, 'Okay', {
            panelClass: ['error-snack'], // add a class to snackbar to add custom styles
        });
        // this.dialog.open(DialogComponent, {
        //     width: '300px',
        //     data: {
        //         header: 'Server Error',
        //         content: message,
        //     },
        // });
    }

    showNonErrorSnackBar(message: string, duration = 2000) {
        this.snackbar.open(message, 'Okay', {
            panelClass: ['non-error-snack'],
            duration,
        });
    }
}
